// extracted by mini-css-extract-plugin
export var orderDetails = "_lv-2";
export var orderImage = "_lv-1";
export var orderMeta = "_lv-3";
export var orderSummary = "_lv-0";
export var rightArrow = "_lv-4";